import React, { ReactNode } from 'react';
import clsx from 'clsx';

import Icon from 'carbon-react/lib/components/icon';

import styles from './ui-selectable-options-card.scss';

interface UISelectableOptionsCardProps {
  checked?: boolean;
  className?: string;
  inputType?: 'radio' | 'checkbox';
  inputName?: string;
  inputValue?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  style?: React.CSSProperties;
  title?: string;
  children?: ReactNode;
  disabled?: boolean;
}

export const UISelectableOptionsCard = (props: UISelectableOptionsCardProps) => {
  const {
    checked = false,
    className,
    inputType,
    inputName,
    inputValue,
    onChange,
    style,
    title,
    children,
    disabled
  } = props;

  const panel = (
    <div
      className={clsx(styles.panel, {
        [styles.disabledPanel]: !!disabled,
        [styles.checkedPanel]: !!checked,
        [styles.notCheckedPanel]: !checked
      })}
      style={inputType ? { cursor: 'pointer' } : { cursor: 'default' }}
    >
      <div
        className={clsx(styles.header, {
          [styles.checkedHeader]: !!checked,
          [styles.notCheckedHeader]: !checked
        })}
      >
        <strong className={styles.title}>{title}</strong>
        <Icon type={checked ? 'tick' : 'none'} className={styles.checkedIcon} color="#00a159" />
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );

  if (inputType) {
    return (
      <div className={clsx(styles.container, className)} style={style} data-testid="UISelectableOptionsCard">
        <label className={styles.label} htmlFor={`UISelectableOptionsCard-${inputName}-${inputValue}`}>
          <input
            id={`UISelectableOptionsCard-${inputName}-${inputValue}`}
            className={styles.input}
            type={inputType}
            name={inputName}
            value={inputValue}
            checked={checked}
            onChange={disabled ? undefined : onChange}
          />
          {panel}
        </label>
      </div>
    );
  } else {
    return panel;
  }
};
